const RANGE = 2 ** 32;

/**
 * A uniformly distributed index in `0 … n-1` (feature plan 0072, the picker gimmick's draw).
 *
 * `crypto.getRandomValues` (available over plain http as well) gives 32-bit values; `value % n` alone would
 * favour the low indices whenever 2^32 is not a multiple of `n`. So values from `limit = 2^32 − (2^32 % n)` on
 * are rejected and drawn again (rejection sampling) — fewer than one in two draws, for any `n`.
 *
 * `fill` is the source, injectable so a test can feed values at the rejection limit. Throws unless `n` is an
 * integer from 1 to 2^32 — with `n = 0` the loop would never end.
 */
export function randomIndex(n: number, fill: (array: Uint32Array<ArrayBuffer>) => Uint32Array = (array) => crypto.getRandomValues(array)): number {
    if (!Number.isInteger(n) || n < 1 || n > RANGE) {
        throw new RangeError(`randomIndex needs an integer from 1 to 2^32, got ${n}`);
    }
    const limit = RANGE - (RANGE % n);
    const buffer = new Uint32Array(1);
    for (;;) {
        const value = fill(buffer)[0];
        if (value < limit) {
            return value % n;
        }
    }
}
